import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  emptyState: 'Nu există înregistrări deocamdată. Reveniți mai târziu.',
  eyebrowCatalog: 'CATALOG AKIS · PUBLIC',
  eyebrowCommunity: 'COMUNITATE AKIS',

  trainingsHeading: 'Calendar instruiri',
  trainingsLead:
    'Sesiuni deschise pentru înscriere, organizate de instituțiile de formare publicate.',
  trainingsOnline: 'ONLINE',
  trainingsOnSite: 'LA SEDIU',
  trainingsMaterialCount: '{{count}} materiale de curs pentru înscriși',
  trainingsMaterialCount_one: 'Un material de curs pentru înscriși',
  trainingsMaterialCount_other: '{{count}} de materiale de curs pentru înscriși',
  trainingsEnrol: 'Înscrie-te (M-Pass)',
  trainingsEnrolAction: 'Înscrie-te la instruire',
  trainingsEnrolBusy: 'Se înscrie…',
  trainingsEnrolled: 'Sunteți înscris la această sesiune.',
  trainingsEnrolledLink: 'Vezi materialele de instruire',
  trainingsEnrolError: 'Înscrierea nu a putut fi făcută. Încercați din nou.',

  fundingHeading: 'Subvenții și granturi',
  fundingLead:
    'Catalogul actualizat al măsurilor de sprijin financiar: domeniu, nivel de sprijin, calendar și stadiu. Abonați-vă la notificări personalizate din cabinetul personal.',
  fundingSupportLevel: 'Nivel de sprijin: {{level}}',
  fundingApply: 'Depune cererea',
  fundingDomain: 'Domeniu: {{domain}}',
  fundingDeadline: 'Termen: {{date}}',
  fundingSessionOver: 'Sesiune finalizată',
  fundingStatusOpen: 'Deschis',
  fundingStatusUpcoming: 'În curând',
  fundingStatusClosed: 'Închis',
  fundingStatusSuspended: 'Suspendat',
  fundingStatusUnknown: 'Necunoscut',

  researchHeading: 'Proiecte de cercetare și inovare',
  researchLead: 'Proiecte de cercetare în derulare și finalizate ale organizațiilor publicate.',
  researchResults: '{{count}} rezultate',
  researchResults_one: '{{count}} rezultat',
  researchResults_other: '{{count}} de rezultate',
  researchBack: 'Înapoi la catalogul de cercetare',
  loading: 'Se încarcă…',
  researchNotFound: 'Proiectul căutat nu există sau nu mai este public.',
  researchResultsHeading: 'Rezultatele proiectului',
  researchNoResultsYet: 'Proiectul nu are încă rezultate publicate.',
  researchNoYear: 'Fără an',
  scientificEventsEyebrow: 'Calendar',
  scientificEventsHeading: 'Evenimente științifice',
  scientificEventsLead:
    'Conferințe, seminare și prezentări ale organizațiilor de cercetare. Apar și în calendarul național al evenimentelor.',
  scientificEventsNext: 'Următoarele evenimente științifice',
  scientificEventsAll: 'Toate evenimentele științifice',
  scientificEventsEmpty: 'Niciun eveniment științific programat.',
  projectPeriodHeading: 'Perioada de implementare',
  projectBudgetHeading: 'Buget',
  projectPartnersHeading: 'Parteneri și roluri',
  projectFundingHeading: 'Surse de finanțare',
  projectObjectivesHeading: 'Obiective',
  projectResultsExpectedHeading: 'Rezultate asteptate',
  projectResultsActualHeading: 'Rezultate actuale',
  documentDownload: 'Descarcă documentul',
  adoptionCount: '{{count}} aplicări în practică',
  adoptionCount_one: 'O aplicare în practică',
  adoptionCount_other: '{{count}} de aplicări în practică',
  adoptionReportedBy: 'Raportat de {{name}}',
  adoptionsFailed: 'Lista aplicărilor nu a putut fi încărcată.',
  discussionHeading: 'Schimb de experiență',
  discussionReplies: '{{count}} mesaje în discuție',
  discussionReplies_one: 'Un mesaj în discuție',
  discussionReplies_other: '{{count}} de mesaje în discuție',
  discussionNoRepliesYet: 'Discuția a fost deschisă. Fiți primul care răspunde.',
  discussionAwaitingModeration: 'Discuția a fost deschisă — primele mesaje sunt în moderare.',
  discussionOpen: 'Deschide discuția',
  discussionStartLead:
    'Nimeni nu a deschis încă o discuție despre acest proiect. Începeți-o cu o întrebare sau cu experiența dumneavoastră din teren.',
  discussionMessageLabel: 'Mesajul dumneavoastră',
  discussionStart: 'Începe discuția',
  discussionSignIn: 'Nimeni nu a deschis încă o discuție despre acest proiect.',
  discussionSignInLink: 'Autentificați-vă pentru a începe una',
  discussionFailed: 'Mesajul nu a putut fi trimis.',
  discussionUnavailable: 'Discuția nu a putut fi încărcată. Reîncercați mai târziu.',
  institutionsHeading: 'Instituții de formare',
  institutionsLead:
    'Instituțiile de formare publicate pe platformă, cu domeniile, echipa și infrastructura lor.',
  institutionsLink: 'Vezi instituțiile de formare',
  institutionPrograms: '{{count}} programe',
  institutionPrograms_one: 'Un program',
  institutionPrograms_other: '{{count}} de programe',
  institutionUpcoming: '{{count}} sesiuni deschise',
  institutionUpcoming_one: 'O sesiune deschisă',
  institutionUpcoming_other: '{{count}} de sesiuni deschise',
  institutionNotFound: 'Instituția căutată nu există sau nu mai este publică.',
  institutionUnavailable:
    'Profilul instituției nu poate fi afișat acum. Încercați din nou mai târziu.',
  institutionBack: 'Înapoi la instituții',
  institutionDomainsHeading: 'Domenii de specializare',
  institutionStaffHeading: 'Echipa didactică',
  institutionInfrastructureHeading: 'Infrastructură',
  institutionZonesHeading: 'Raioane deservite',
  institutionProgramsHeading: 'Portofoliul de programe',
  institutionSeeOnMap: 'Vezi pe hartă',
  orgsHeading: 'Organizații de cercetare și inovare',
  orgsLead: 'Instituțiile de cercetare publicate pe platformă, cu expertiza și infrastructura lor.',
  orgsLink: 'Vezi organizațiile',
  orgProjects: '{{count}} proiecte',
  orgProjects_one: '{{count}} proiect',
  orgProjects_other: '{{count}} de proiecte',
  orgResults: '{{count}} rezultate',
  orgResults_one: '{{count}} rezultat',
  orgResults_other: '{{count}} de rezultate',
  orgNotFound: 'Organizația căutată nu există sau nu mai este publică.',
  orgBack: 'Înapoi la organizații',
  orgOverviewHeading: 'Prezentare',
  orgInfrastructureHeading: 'Infrastructură de cercetare',
  orgContactHeading: 'Contact',
  orgExpertiseHeading: 'Domeniu de expertiză',
  orgProjectsHeading: 'Proiectele instituției',
  orgResultsHeading: 'Rezultatele publicate',
  projectStatusONGOING: 'În derulare',
  projectStatusCOMPLETED: 'Finalizat',
  resultTypePUBLICATION: 'Publicație',
  resultTypePATENT: 'Brevet',
  resultTypeTECHNOLOGY: 'Tehnologie',
  resultTypeTRANSFER_ACTIVITY: 'Activitate de transfer',

  servicesHeading: 'Servicii de consiliere agricolă',
  servicesLead: 'Furnizori publicați și serviciile disponibile la nivel local.',
  servicesSearchLabel: 'Caută servicii',
  servicesSearchPlaceholder: 'Serviciu sau furnizor',
  providerServiceCount: '{{count}} servicii',
  providerServiceCount_one: '{{count}} serviciu',
  providerServiceCount_other: '{{count}} de servicii',
  providerNotFound: 'Furnizorul căutat nu există sau nu mai este public.',
  providerBack: 'Înapoi la servicii',
  providerNoServices: 'Acest furnizor nu are încă niciun serviciu publicat.',
  providerSeeOnMap: 'Vezi pe hartă',
  providerCoverageZones: 'Zone de acoperire',

  communityHeading: 'Comunitate, forumuri și discuții',
  communityLead:
    'Schimb de idei, întrebări și bune practici între fermieri, consilieri și cercetători.',
  communityForums: 'Forumuri tematice',
  communityQa: 'Sesiuni de întrebări și răspunsuri cu experți',
  communityAssociations: 'Asociații și organizații profesionale',

  agenciesHeading: 'Agenții de sprijin și proiecte strategice',
  agenciesLead:
    'Programe guvernamentale, internaționale și ale partenerilor de dezvoltare care sprijină sectorul agricol.',
  agenciesSponsorGovernmental: 'Program guvernamental',
  agenciesSponsorInternational: 'Program internațional',
  agenciesSponsorPartner: 'Partener de dezvoltare',
  agenciesThematicAreas: 'Domenii tematice: {{areas}}',
} as const;

const en = {
  emptyState: 'No records yet. Please check back later.',
  eyebrowCatalog: 'AKIS CATALOGUE · PUBLIC',
  eyebrowCommunity: 'AKIS COMMUNITY',

  trainingsHeading: 'Training calendar',
  trainingsLead: 'Sessions open for enrolment, run by published training institutions.',
  trainingsOnline: 'ONLINE',
  trainingsOnSite: 'ON SITE',
  trainingsMaterialCount: '{{count}} course materials for enrolled learners',
  trainingsMaterialCount_one: 'One course material for enrolled learners',
  trainingsMaterialCount_other: '{{count}} course materials for enrolled learners',
  trainingsEnrol: 'Enrol (M-Pass)',
  trainingsEnrolAction: 'Enrol in training',
  trainingsEnrolBusy: 'Enrolling…',
  trainingsEnrolled: 'You are enrolled in this session.',
  trainingsEnrolledLink: 'View your training materials',
  trainingsEnrolError: 'The enrolment could not be made. Please try again.',

  fundingHeading: 'Subsidies and grants',
  fundingLead:
    'The current catalogue of financial support measures: field, support level, timetable and stage. Subscribe to personalised notifications from your personal account.',
  fundingSupportLevel: 'Support level: {{level}}',
  fundingApply: 'Apply',
  fundingDomain: 'Domain: {{domain}}',
  fundingDeadline: 'Deadline: {{date}}',
  fundingSessionOver: 'Session closed',
  fundingStatusOpen: 'Open',
  fundingStatusUpcoming: 'Upcoming',
  fundingStatusClosed: 'Closed',
  fundingStatusSuspended: 'Suspended',
  fundingStatusUnknown: 'Unknown',

  researchHeading: 'Research and innovation projects',
  researchLead: 'Ongoing and completed research projects of published organisations.',
  researchResults: '{{count}} results',
  researchResults_one: '{{count}} result',
  researchBack: 'Back to the research catalogue',
  loading: 'Loading…',
  researchNotFound: 'This project does not exist, or is no longer public.',
  researchResultsHeading: 'Project results',
  researchNoResultsYet: 'This project has no published results yet.',
  researchNoYear: 'No year',
  scientificEventsEyebrow: 'Calendar',
  scientificEventsHeading: 'Scientific events',
  scientificEventsLead:
    'Conferences, seminars and presentations by the research organisations. They also appear in the national events calendar.',
  scientificEventsNext: 'Upcoming scientific events',
  scientificEventsAll: 'All scientific events',
  scientificEventsEmpty: 'No scientific event is scheduled.',
  projectPeriodHeading: 'Implementation period',
  projectBudgetHeading: 'Budget',
  projectPartnersHeading: 'Partners and roles',
  projectFundingHeading: 'Funding sources',
  projectObjectivesHeading: 'Objectives',
  projectResultsExpectedHeading: 'Expected results',
  projectResultsActualHeading: 'Results achieved',
  documentDownload: 'Download the document',
  adoptionCount: '{{count}} adoptions in practice',
  adoptionCount_one: 'One adoption in practice',
  adoptionReportedBy: 'Reported by {{name}}',
  adoptionsFailed: 'The list of adoptions could not be loaded.',
  discussionHeading: 'Exchange of experience',
  discussionReplies: '{{count}} messages in the discussion',
  discussionReplies_one: 'One message in the discussion',
  discussionNoRepliesYet: 'The discussion is open. Be the first to reply.',
  discussionAwaitingModeration: 'The discussion is open — the first messages are with a moderator.',
  discussionOpen: 'Open the discussion',
  discussionStartLead:
    'Nobody has opened a discussion about this project yet. Start one with a question or with your own experience from the field.',
  discussionMessageLabel: 'Your message',
  discussionStart: 'Start the discussion',
  discussionSignIn: 'Nobody has opened a discussion about this project yet.',
  discussionSignInLink: 'Sign in to start one',
  discussionFailed: 'The message could not be sent.',
  discussionUnavailable: 'The discussion could not be loaded. Try again later.',
  institutionsHeading: 'Training institutions',
  institutionsLead:
    'The training institutions published on the platform, with their domains, staff and facilities.',
  institutionsLink: 'See the training institutions',
  institutionPrograms: '{{count}} programmes',
  institutionPrograms_one: 'One programme',
  institutionPrograms_other: '{{count}} programmes',
  institutionUpcoming: '{{count}} open sessions',
  institutionUpcoming_one: 'One open session',
  institutionUpcoming_other: '{{count}} open sessions',
  institutionNotFound: 'The institution you are looking for does not exist or is no longer public.',
  institutionUnavailable:
    'The institution’s profile cannot be shown right now. Please try again later.',
  institutionBack: 'Back to the institutions',
  institutionDomainsHeading: 'Specialisation domains',
  institutionStaffHeading: 'Teaching staff',
  institutionInfrastructureHeading: 'Infrastructure',
  institutionZonesHeading: 'Districts served',
  institutionProgramsHeading: 'Programme portfolio',
  institutionSeeOnMap: 'See on the map',
  orgsHeading: 'Research and innovation organisations',
  orgsLead:
    'The research institutions published on the platform, with their expertise and infrastructure.',
  orgsLink: 'See the organisations',
  orgProjects: '{{count}} projects',
  orgProjects_one: '{{count}} project',
  orgResults: '{{count}} results',
  orgResults_one: '{{count}} result',
  orgNotFound: 'This organisation does not exist, or is no longer public.',
  orgBack: 'Back to the organisations',
  orgOverviewHeading: 'Overview',
  orgInfrastructureHeading: 'Research infrastructure',
  orgContactHeading: 'Contact',
  orgExpertiseHeading: 'Areas of expertise',
  orgProjectsHeading: 'The institution’s projects',
  orgResultsHeading: 'Published results',
  projectStatusONGOING: 'Ongoing',
  projectStatusCOMPLETED: 'Completed',
  resultTypePUBLICATION: 'Publication',
  resultTypePATENT: 'Patent',
  resultTypeTECHNOLOGY: 'Technology',
  resultTypeTRANSFER_ACTIVITY: 'Transfer activity',

  servicesHeading: 'Agricultural advisory services',
  servicesLead: 'Published providers and the services available locally.',
  servicesSearchLabel: 'Search services',
  servicesSearchPlaceholder: 'Service or provider',
  providerServiceCount: '{{count}} services',
  providerServiceCount_one: '{{count}} service',
  providerNotFound: 'This provider does not exist, or is no longer public.',
  providerBack: 'Back to services',
  providerNoServices: 'This provider has no published services yet.',
  providerSeeOnMap: 'See on the map',
  providerCoverageZones: 'Coverage zones',

  communityHeading: 'Community, forums and discussions',
  communityLead:
    'Exchange of ideas, questions and good practice between farmers, advisers and researchers.',
  communityForums: 'Thematic forums',
  communityQa: 'Expert Q&A sessions',
  communityAssociations: 'Professional associations and organisations',

  agenciesHeading: 'Support agencies and strategic programmes',
  agenciesLead:
    'Governmental, international and development-partner programmes supporting the agricultural sector.',
  agenciesSponsorGovernmental: 'Governmental programme',
  agenciesSponsorInternational: 'International programme',
  agenciesSponsorPartner: 'Development partner',
  agenciesThematicAreas: 'Thematic areas: {{areas}}',
} satisfies Translation<keyof typeof ro>;

export const publicCatalog = { ro, en } satisfies Dictionary;

export type PublicCatalogKey = keyof typeof ro;
